import React, { useEffect, useState } from "react";
import successLogo from "../../assets/images/payment-success.png";

type Props = {
  message?: string;
};

export const PaymentSuccess: React.FC<Props> = ({ message }) => {
  const [seconds, setSeconds] = useState(5);

  useEffect(() => {
    // countdown interval
    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    // redirect timeout
    const timeout = setTimeout(() => {
      window.history.back();
      // or use navigate("/") if using react-router
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          backgroundColor: "rgba(128, 128, 128, 0.1)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            height: "50vh",
            color: "black",
            fontSize: "25px",
            flexDirection: "column",
            width: "80%",
            maxWidth: "500px",
            gap: "40px",
            backgroundColor: "#fff",
            padding: "1rem",
            borderRadius: "5px",
          }}
        >
          <img src={successLogo} alt="" />
          <p style={{ textAlign: "center", margin: "0px auto" }}>
            {message ?? "Payment completed successfully"}
          </p>
        </div>
      </div>
    </>
  );
};
